import { useContext } from 'react'

import { AuthContext, CognitoState } from '../contexts/CognitoContext'

const useAuth = () => {
    const context = useContext(AuthContext)

    if (!context) throw new Error('AuthContext must be placed within AuthProvider')

    return context as CognitoState
}

export default useAuth
